import * as React from 'react';
import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { IoMdCart } from "react-icons/io";
import { useDispatch, useSelector } from 'react-redux';
import { MdClose } from "react-icons/md";
import { toggleSibar } from '../../features/someFunctionality/funSlice';

export default function Sidebar({ mdmain, side, forItem, children }) {
    const { cartProducts } = useSelector((state) => state.cartProducts);
    const { sides } = useSelector((state) => state.someFun);

    const dispatch = useDispatch();

    const toggleDrawer = (anchor, open) => (event) => {
        dispatch(toggleSibar({ anchor, open }))
    };

    const { i18n } = useSelector(state => state.someFun);
    const [translate, setTranslate] = React.useState(true);

    React.useEffect(() => {
        if (i18n === 'en') {
            setTranslate(true)
        }
        else {
            setTranslate(false)
        }
    }, [i18n]);

    const list = (anchor) => (
        <Box
            sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 350 }}
            role="presentation"
            //   onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}
        >
            <div className='md:px-2 px-5 pt-4'>
                <div className='flex text-xl font-poppins font-bold mb-0'>
                    <div className='w-4/5'>
                        <h3 className='text-lg'>{translate ? "YOUR CART" : "আপনার কার্ট"}</h3>
                    </div>
                    <div onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)} className='w-1/5 flex justify-end cursor-pointer'>
                        <MdClose className='text-3xl font-bold' />
                    </div>
                </div>
            </div>
            {children}
        </Box>
    );

    return (
        <div className='grid content-center'>
            <React.Fragment>
                {forItem === 'cart' &&
                    <>
                        {cartProducts.length > 0 ?
                            <button onClick={toggleDrawer(side, true)} type="button" className="focus:outline-none inline-flex relative items-center text-sm font-medium text-center text-white">
                                <IoMdCart className='block text-2xl text-gray-600 hover:text-bnd-1' />
                                {mdmain === true && cartProducts.length < 1 ? "" :
                                    <>
                                        <span className="sr-only">Notifications</span>
                                        <div className="inline-flex absolute -top-3 -right-0 rounded justify-center items-center w-auto px-1 h-5 text-xs font-semibold text-white bg-bnd-1">{cartProducts ? cartProducts.length : 0}</div>
                                    </>
                                }
                            </button>
                            :
                            <button onClick={toggleDrawer(side, true)} type="button" className="block md:hidden focus:outline-none relative items-center text-sm font-medium text-center text-white">
                                <IoMdCart className='block text-2xl text-gray-600 hover:text-bnd-1' />
                                {mdmain === true && cartProducts.length < 1 ? "" :
                                    <>
                                        <span className="sr-only">Notifications</span>
                                        <div className="inline-flex absolute -top-2 -right-0 rounded justify-center items-center w-auto px-1 h-5 text-xs font-semibold text-white bg-bnd-1">{cartProducts ? cartProducts.length : 0}</div>
                                    </>
                                }
                            </button>
                        }
                    </>
                }
                {forItem === 'serch' &&
                    <i onClick={toggleDrawer(side, true)} className="fa fa-search text-xl text-gray-500 hover:text-bnd-1" aria-hidden="true"></i>
                }
                <SwipeableDrawer
                    anchor={side}
                    open={sides[side]}
                    onClose={toggleDrawer(side, false)}
                    onOpen={toggleDrawer(side, true)}
                >
                    {list(side)}
                </SwipeableDrawer>
            </React.Fragment>
        </div>
    );
}
